/**
 * Route SEO helpers — data lives in routeSeoData.js (shared with sitemap generator).
 */
const { routeSeoMap, sitelinkNavOrder, blogSlugs } = require('./routeSeoData.js');

const SITE = 'https://genzix.in';

const normalizePath = (pathname) => {
  const p = (pathname || '/').toLowerCase().replace(/\/$/, '') || '/';
  return p;
};

export { routeSeoMap, sitelinkNavOrder, blogSlugs };

const buildStructuredData = (entry, canonicalUrl) => {
  if (!entry.schemaType) return null;

  const base = {
    name: entry.title,
    description: entry.description,
    url: canonicalUrl,
  };

  switch (entry.schemaType) {
    case 'Service':
      return {
        '@context': 'https://schema.org',
        '@type': 'Service',
        ...base,
        provider: { '@type': 'Organization', name: 'Genzix', url: SITE },
        areaServed: 'Worldwide',
      };
    case 'CollectionPage':
      return { '@context': 'https://schema.org', '@type': 'CollectionPage', ...base };
    case 'AboutPage':
      return {
        '@context': 'https://schema.org',
        '@type': 'AboutPage',
        ...base,
        mainEntity: { '@type': 'Organization', name: 'Genzix', url: SITE },
      };
    case 'ContactPage':
      return { '@context': 'https://schema.org', '@type': 'ContactPage', ...base };
    case 'Blog':
      return { '@context': 'https://schema.org', '@type': 'Blog', ...base, publisher: { '@type': 'Organization', name: 'Genzix' } };
    case 'CreativeWork':
      return {
        '@context': 'https://schema.org',
        '@type': 'CreativeWork',
        ...base,
        creator: { '@type': 'Organization', name: 'Genzix', url: SITE },
        image: entry.ogImage,
      };
    default:
      return null;
  }
};

export const getSeoForPath = (pathname) => {
  const path = normalizePath(pathname);
  const entry = routeSeoMap[path];
  if (!entry) return null;

  const canonicalPath = entry.canonicalPath || path;
  const canonicalUrl = `${SITE}${canonicalPath === '/' ? '/' : canonicalPath}`;

  return {
    ...entry,
    path,
    canonicalUrl,
    ogUrl: `${SITE}${path === '/' ? '/' : path}`,
    structuredData: buildStructuredData(entry, canonicalUrl),
  };
};

export const buildSiteNavigationJsonLd = () =>
  sitelinkNavOrder
    .map((path, index) => {
      const seo = routeSeoMap[path];
      if (!seo) return null;
      return {
        '@context': 'https://schema.org',
        '@type': 'SiteNavigationElement',
        position: index + 1,
        name: seo.navName || seo.title,
        description: seo.navDescription || seo.description,
        url: `${SITE}${path === '/' ? '/' : path}`,
      };
    })
    .filter(Boolean);

export const getSitemapEntries = () => {
  const today = new Date().toISOString().slice(0, 10);
  return Object.entries(routeSeoMap).map(([path, meta]) => ({
    loc: `${SITE}${path === '/' ? '/' : path}`,
    lastmod: meta.lastmod || today,
    changefreq: meta.changefreq || 'monthly',
    priority: meta.priority || '0.8',
    ogImage: meta.ogImage,
    imageTitle: meta.imageTitle,
    imageCaption: meta.imageCaption,
  }));
};

export default routeSeoMap;
